<template>
  <v-dialog max-width="300" persistent v-model="showDialog">
    <v-card class="mx-auto">
      <!--   Fixes broken padding   -->
      <p style="color: white">.</p>
      <v-card-subtitle v-html="message" />
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="showDialog = false" text>
          Katkesta
        </v-btn>
        <v-btn
          color="error"
          text
          @click="
            showDialog = false
            $emit('forceSave')
          "
        >
          Salvesta ikkagi
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      require: true
    },
    message: {
      type: String,
      require: true
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
